import React from "react";
import { BsHeartFill } from "react-icons/bs";

function CardMain({ imgSrc, title, hearts }) {
  return (
    <div className="card_main">
      <img src={imgSrc} alt="" />

      <div className="card_main_name">
        <h2>{title}</h2>

        <div className="card_icon">
          <i>
            {" "}
            <BsHeartFill /> <span>{hearts}</span>{" "}
          </i>
        </div>
      </div>

      <div className="stats">
        <p>
          Oferta atual <span>1.2 ETH</span>
        </p>
        <p>
          Termina em <span>1d:12h:10m</span>
        </p>
      </div>

      <div className="card_button">
        <a href="http://localhost:3000" className="button1 btn">
          Fazer um lance
        </a>
        <a href="http://localhost:3000" className="button2 btn">
          Histórico
        </a>
      </div>
    </div>
  );
}

export default CardMain;
